<div class="panel-content" *ngIf="shouldShowToggleFeedbackPanel()" [ngClass]="{'collapsed': (feedbackSessionService.isPanelOpen$ | async) !== true}">
	<div class="mobile-handle-spacer"></div>
	<mat-tab-group
		(selectedIndexChange)="changeTab($event)"
		color="accent"
		[attr.aria-label]="
			'feedback-session-feedback-display_feedbacks-types' | translate
		"
		#tabGroup
		[selectedIndex]="selectedIndex$ | async"
	>
		<mat-tab *ngIf="canSeeCommentKind()">
			<ng-template mat-tab-label>
				<span class="feedback-tab comment-tab" data-cy="comment-tab-button">
					<span class="tab-icon">
						<i class="ficon-app-comment-multiple-outline"></i>
					</span>
					<span
						class="tab-title"
						translate="feedback-session_controller-comments"
					></span>
				</span>
				<span
					*ngIf="showNewCommentsIndicator$ | async"
					class="comment-indicator"
					[ngClass]="{pulse: isPulsing$ | async}"
					role="alert"
					aria-live="polite"
					[attr.aria-label]="
						'feedback-session-feedback-display_new-comments'
							| translate : {count: newComments}
					"
				>
					{{newComments}}
				</span>
			</ng-template>
		</mat-tab>
		<mat-tab *ngIf="canSeeRubricKind()">
			<ng-template mat-tab-label>
				<span class="feedback-tab rubric-tab"  data-cy="rubric-tab-button">
					<span class="tab-icon">
						<i class="ficon-app-rubric"></i>
					</span>
					<span
						class="tab-title"
						translate="feedback-session_controller-evaluations"
					></span>
				</span>
			</ng-template>
		</mat-tab>
		<mat-tab>
			<ng-template mat-tab-label>
				<span class="feedback-tab information-tab" data-cy="information-tab-button">
					<span class="tab-icon">
						<i class="ficon-app-information-outline"></i>
					</span>
					<span class="tab-title" translate="activity-info_details"></span>
				</span>
			</ng-template>
		</mat-tab>
		<mat-tab *ngIf="canSeeTranscriptions()">
			<ng-template mat-tab-label>
				<span class="feedback-tab transcription-tab" data-cy="transcription-tab-button">
					<span class="tab-icon">
						<i class="ficon-transcription"></i>
					</span>
					<span
						class="tab-title"
						translate="feedback-session-feedback-display_transcript-header"
					></span>
				</span>
			</ng-template>
		</mat-tab>
		<mat-tab *ngIf="canSeeAnalytics()">
			<ng-template mat-tab-label>
				<span class="feedback-tab analytics-tab" data-cy="analytics-tab-button">
					<span class="tab-icon">
						<i class="ficon-analytics"></i>
					</span>
					<span
						class="tab-title"
						translate="feedback-session-feedback-display_analytics-header"
					></span>
				</span>
			</ng-template>
		</mat-tab>
	</mat-tab-group>
	<span class="expand-button-container">
		<button
			class="expand-button"
			(click)="feedbackSessionService.togglePanel()"
			[matTooltip]="(feedbackSessionService.isPanelOpen$ | async) ? ('common_close-sidepanel' | translate) : ('common_open-sidepanel' | translate)"
		>
			<i [ngClass]="(feedbackSessionService.isPanelOpen$ | async) ? 'ficon-app-chevron-right' : 'ficon-app-chevron-left'"></i>
		</button>
	</span>
</div>
